/**
 * Context: NFCContext
 * Provee funcionalidad NFC global
 */

import React, { createContext, useContext } from 'react';
import useNFC from '../hooks/useNFC';

const NFCContext = createContext(null);

export const NFCProvider = ({ children }) => {
  const nfc = useNFC();

  return (
    <NFCContext.Provider value={nfc}>
      {children}
    </NFCContext.Provider>
  );
};

export const useNFCContext = () => {
  const context = useContext(NFCContext);
  
  if (!context) {
    throw new Error('useNFCContext debe usarse dentro de NFCProvider');
  }
  
  return context;
};

export default NFCContext;
